<template>
  <div class="page-title">
    <div
      style="justify-content: space-between"
      class="d-flex alert-primary-new"
    >
      <div>
        <!-- <img src="../assets/images/logo/label-icon.svg" class="icon-info-alt" /> -->

        <div style="display: flex">
          <img
            class="img-fluid for-light m-r-20"
            src="../assets/images/logo/label-icon.svg"
            alt=""
          />
          <h5 class="m-t-5 font-bold">{{ title }}</h5>
        </div>
        <ol style="list-style-type: disc" class="m-l-20">
          <li v-for="(item, id) in main" :key="id">
            {{ item.childMsg }}
          </li>
        </ol>
      </div>
      <!-- <div class="col-sm-6"></div> -->
      <div class="img-label">
        <img class="" src="../assets/images/svg-img/label-img.svg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      default: "home",
    },
    main: {
      default: "",
    },
  },
};
</script>
<style scoped>
.img-label {
  opacity: 1;
  text-align: right;
}
.font-bold {
  font-weight: bold;
}
.alert-primary-new {
  background-color: #00a3e9;
  border-radius: 5px;
  border-color: #00a3e9;
  color: #fff;
}
</style>
